'use strict';

var cache = {};

module.exports = {
    initCache: function () {
        cache.$passwordInput = $('#passwordx');
        cache.$saveBtn = $('.btn-save');
    },
    enableButton: function () {
        cache.$passwordInput.on('keyup change', function () {
            var $this = $(this);

            if ($this.val() != '') {
                cache.$saveBtn.removeAttr('disabled');
            } else {
                cache.$saveBtn.attr('disabled', 'true');
            }
        });
    }
};
